import { defineStore } from 'pinia';
import { useListMappingTraces } from '../api/listMappingTraces';
import { useMappingTraceStore } from 'shared/products/mapping/stores/mappingTraceStore';

export const useRefreshMappingTraceStore = defineStore('refresh-mapping-traces', () => {
  const listMappingTraces = useListMappingTraces();
  const store = useMappingTraceStore();

  async function initialize() {
    const response = await listMappingTraces.execute();
    if (!response.ok) return;

    store.merge(response.mappingTraces);
  }

  return {
    initialize,
  };
});
